export default __webpack_public_path__ + "static/media/hepatology.07e50fe1.png";